export const PathDefinition = {
    home: '/',
    account: '/account',
    signIn: '/signIn',
    forgotPassword: '/forgotPassword',
    listDirectOrder: '/listDirectOrder',
    importDirectOrder: '/importDirectOrder',
    importUpdateDirectOrderStatus: '/importUpdateDirectOrderStatus'
};
